"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prettyDateFormat = exports.parseDate = exports.getTime = exports.formatLastTimeOnlineChatListItem = exports.formatLastTimeOnline = void 0;
var parseDate = exports.parseDate = function parseDate(microseconds) {
  var date = /^\d+$/.test(microseconds) ? Number(microseconds) / 1000 : microseconds;
  return new Date(date);
};
var weekDaysNames = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'];
var monthsNames = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
var isToday = function isToday(time) {
  return time.toDateString() === new Date().toDateString();
};
var isYesterday = function isYesterday(time) {
  var today = new Date();
  var yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
  return time > yesterday;
};
var isWithinAWeek = function isWithinAWeek(time) {
  var today = new Date();
  var lastWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
  return time > lastWeek;
};
var isWithinAYear = function isWithinAYear(time) {
  var today = new Date();
  var lastYear = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate());
  return time > lastYear;
};
var getTime = exports.getTime = function getTime(date) {
  var hours = "".concat(date.getHours()).padStart(2, '0');
  var minutes = "".concat(date.getMinutes()).padStart(2, '0');
  return "".concat(hours, ":").concat(minutes);
};
var getWeekDay = function getWeekDay(date) {
  return weekDaysNames[date.getDay()];
};
var getMonth = function getMonth(date) {
  return monthsNames[date.getMonth()];
};
var getDate = function getDate(date) {
  var day = "".concat(date.getDate()).padStart(2, '0');
  var month = "".concat(date.getMonth() + 1).padStart(2, '0');
  var year = date.getFullYear();
  return "".concat(day, "/").concat(month, "/").concat(year);
};
var getLongDate = function getLongDate(date) {
  var day = date.getDate();
  var month = getMonth(date);
  var year = date.getFullYear();
  var weekDay = getWeekDay(date);
  return "".concat(weekDay, ", ").concat(day, " de ").concat(month, " de ").concat(year);
};
var getLongDateWithoutYear = function getLongDateWithoutYear(date) {
  var day = date.getDate();
  var month = getMonth(date);
  var weekDay = getWeekDay(date);
  return "".concat(weekDay, ", ").concat(day, " de ").concat(month);
};
var prettyDateFormat = exports.prettyDateFormat = function prettyDateFormat(timestamp) {
  var showTodaysTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var date = parseDate(timestamp);
  if (isToday(date)) {
    return showTodaysTime ? getTime(date) : 'Hoje';
  }
  if (isYesterday(date)) {
    return 'Ontem';
  }
  if (isWithinAWeek(date)) {
    return getWeekDay(date);
  }
  if (isWithinAYear(date)) {
    return getLongDateWithoutYear(date);
  }
  return getLongDate(date);
};
var formatLastTimeOnline = exports.formatLastTimeOnline = function formatLastTimeOnline(timestamp) {
  var date = parseDate(timestamp);
  if (isToday(date)) {
    return "\xE0s ".concat(getTime(date));
  }
  if (isYesterday(date)) {
    return "ontem \xE0s ".concat(getTime(date));
  }
  return "em ".concat(getDate(date));
};
var formatLastTimeOnlineChatListItem = exports.formatLastTimeOnlineChatListItem = function formatLastTimeOnlineChatListItem(timestamp) {
  var showTodaysTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var date = parseDate(timestamp);
  if (isToday(date)) {
    return showTodaysTime ? getTime(date) : 'Hoje';
  }
  if (isYesterday(date)) {
    return 'Ontem';
  }
  if (isWithinAWeek(date)) {
    return getWeekDay(date);
  }
  if (isWithinAYear(date)) {
    return getDate(date);
  }
  return getLongDate(date);
};